import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

import ProcessSubtypeEdit from './ProcessSubtypeEdit';
import getLocale from '../../../i18n/getLocale';

class ProcessesEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      documents_list: [],
      subtypes_data: [],
      name_subtype: '',
      id: this.props.process_id,
      name: this.props.process_data.name,
    };

    this.locale = getLocale();

    //bind específico
    this.edit = this.edit.bind(this);
    this.addSubtype = this.addSubtype.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined' && typeof newProps.process_data.name !== 'undefined') {
      this.setState({
        id: newProps.process_id,
        name: newProps.process_data.name,
      });
    }
    if(Array.isArray(newProps.documents_list)) {
      this.setState({documents_list: newProps.documents_list});
    }
    if(Array.isArray(newProps.subtypes_data)) {
      this.setState({subtypes_data: newProps.subtypes_data});
    }
  }
  
  
  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/processo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addSubtype(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name_subtype,
      process_id: this.state.id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/processo/subtipo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.refreshSubtypes(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.edit}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Processos.EditarProcesso.tabDadosDoProcesso.formulario.Nome}:</label>
          <input type="text" name="name" className="form-control" placeholder={this.locale.Processos.EditarProcesso.tabDadosDoProcesso.formulario.placeholder.NomeDoProcesso} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <div className="col-md-6">
        <button type="submit" className="btn btn-primary btn-inline btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvarEdicao}</button>
      </div>
    </div>
  </form>
  <hr/>
  <h3>{this.locale.Processos.EditarProcesso.tabDadosDoProcesso.tituloAdicionarNovoSubtipo}</h3>
  <form onSubmit={this.addSubtype}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Processos.EditarProcesso.tabDadosDoProcesso.formularioAdicionarNovoSubtipo.NomeDoSubtipo}:</label>
          <input type="text" name="name_subtype" className="form-control" placeholder={this.locale.Processos.EditarProcesso.tabDadosDoProcesso.formularioAdicionarNovoSubtipo.placeholder.NomeDoSubtipo} value={this.state.name_subtype} onChange={this.handleChange.bind(this, 'name_subtype')} />
        </div>
      </div>
      <div className="col-md-6">
        <button type="submit" className="btn btn-primary btn-inline btn-lg btn-block"><i className="fa fa-fw fa-plus"></i> {this.locale.Processos.EditarProcesso.tabDadosDoProcesso.formularioAdicionarNovoSubtipo.botaoAdicionarSubtipo}</button>
      </div>
    </div>
  </form>
  <hr/>
  {Object.keys(self.state.subtypes_data).map(function(k) {
    return (
      <ProcessSubtypeEdit RequestApi={self.refs.request_api} process_id={self.state.id} handleAlert={self.props.handleAlert} refreshSubtypes={self.props.refreshSubtypes} documents_list={self.props.documents_list} process_subtype_id={self.state.subtypes_data[k].id} subtype_data={self.state.subtypes_data[k]} />
    );
  })}
</div>
    );
  }
}

export default ProcessesEditTab;



// WEBPACK FOOTER //
// ./src/Components/Processes/Elements/ProcessesEditTab.js